module.exports = __webpack_public_path__ + "img/right.53fd7d6b.png";